import React from "react";

import { applyStyleToSelectedRange, applyFormatToSelectedRange } from "../../RichTextEditor";
import Button from "../../Shared/UI/Button/components/Button";
import Tooltip from "../../Shared/UI/Tooltip/components/Tooltip";
import BoldIcon from '../../Shared/UI/BoldIcon/components/BoldIcon';
import ItalicIcon from '../../Shared/UI/ItalicIcon/components/ItalicIcon';
import UnorderedListIcon from '../../Shared/UI/UnorderedListIcon/components/UnorderedListIcon';

import styles from './Resume.module.scss';

const ResumeFormattingControls = ({ contentEditable, setState, activeStyleTypes = [], activeFormat }) => {
  return (
    <>
      {contentEditable && (
        <div className={styles.stylingTool}>
          <Tooltip content="Bold" position="bottom">
            <Button
              variant="secondary"
              icon={<BoldIcon />}
              iconOnly
              aria-label="Bold"
              pressed={activeStyleTypes.includes('b')}
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => applyStyleToSelectedRange({ style: { type: 'b' }, setState })}
            />
          </Tooltip>
          <Tooltip content="Italic" position="bottom">
            <Button
              variant="secondary"
              icon={<ItalicIcon />}
              iconOnly
              aria-label="Italic"
              pressed={activeStyleTypes.includes('i')}
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => applyStyleToSelectedRange({ style: { type: 'i' }, setState })}
            />
          </Tooltip>
          <Tooltip content="Unordered List" position="bottom">
            <Button
              variant="secondary"
              icon={<UnorderedListIcon />}
              iconOnly
              aria-label="Unordered List"
              pressed={activeFormat === 'DocumentUnorderedList' || activeFormat === 'DocumentUnorderedListItem'}
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => applyFormatToSelectedRange({ format: { type: 'DocumentUnorderedList' }, setState })}
            />
          </Tooltip>
        </div>
      )}
    </>
  );
};

export default ResumeFormattingControls;
